import { NodeModel } from '@minoru/react-dnd-treeview';
import { InterruptionModel } from '../../models/interruptions/interruptionList.model';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    workshiftShedulingList: WorkshiftsListModel;
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
    openUpdateAndDeleteAdditionalHoursModal: (
        startDate: string,
        endDate: string,
        employee: NodeModel[],
        additionals: InterruptionModel[][]
    ) => void;
};

export const controllerModifyAdditionalTimeModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    workshiftShedulingList,
    getWorkshiftScheduling,
    openUpdateAndDeleteAdditionalHoursModal,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);
    let dates = getDatesBetweenDates(initDate, lastDate);

    let additionalsList: InterruptionModel[][] = [];

    for (let emp = 0; emp < selectedEmployees?.length; emp++) {
        let newAdditionals: InterruptionModel[] = [];

        for (let date = 0; date < dates?.length; date++) {
            let schedulings = getWorkshiftScheduling(
                dates[date],
                selectedEmployees[emp].id,
                workshiftShedulingList
            );

            if (
                schedulings &&
                schedulings.employeeId === selectedEmployees[emp].id
            ) {
                let { businessUnit, costCenters , employeeId } = schedulings;
                let additionals = schedulings.additionalTimes;

                additionals.forEach((add) => {
                    let additional: InterruptionModel = {
                        createdDate: add.createdDate,
                        createdBy: add.createdBy.toString(),
                        interruptionTypeId: add.interruptionTypeId,
                        startDate: add.startTimeAdditionalTime,
                        endDate: add.endTimeAdditionalTime,
                        id: add.id,
                        companyId: add.companyId,
                        employeeFullName: add.employeeFullName,
                        groupId: add.groupId,
                        hourTypeId: add.hourTypeId,
                        observations: add.observations,
                        employeeId: employeeId,
                        isAdditionalHour: true,
                        businessUnit,
                        costCenters,
                        isAutomaticDiscount: false,
                        isOnlyOvertime: false,
                        isPaid: false,
                        nickName: 'HOAD',
                        interruptionReferenceId: add.interruptionReferenceId,
                    };

                    newAdditionals.push(additional);
                });
            }
        }

        if (newAdditionals?.length > 0) additionalsList.push(newAdditionals);
    }

    if (
        initDate &&
        lastDate &&
        selectedEmployees?.length > 0 &&
        additionalsList[0]?.length > 0
    ) {
        openUpdateAndDeleteAdditionalHoursModal(
            initDate,
            lastDate,
            selectedEmployees,
            additionalsList
        );
    }
};
